import { createAsyncThunk } from '@reduxjs/toolkit';
import history from '~/history';
import { setNotification } from '../main';
import { setLanguage, setEmployeeId } from '~/utils/sessionStorage';
import { changeLanguage } from '~/store/layout';
import { RootState } from '..';
import DictionaryApi from '~/api/dictionaries';
import { setEmployee } from '~/store/auth';
import { t } from '~/utils/lang';
import { TokenTransferResponse } from '~/api/tokenTransfer';

export const loginAction = createAsyncThunk<any, TokenTransferResponse>(
  'auth/loginAction',
  async (userData, { dispatch }) => {
    try {
      const { company, branch, language } = userData;

      if (!company) {
        throw new Error('No company data');
      }

      if (language) {
        const lang = language.toUpperCase();
        setLanguage(lang);
        t.setLang(lang);
        dispatch(changeLanguage(lang as any));
      }

      return {
        company: {
          id: company.id,
          label: company.name,
          value: company.dbName,
          timeClockingLevels: company.timeClockingLevels || [],
        },
        branch: {
          value: branch?.value || '',
          label: '',
          isAutoStartStop: false,
        },
        userId: userData.userId || '',
      };
    } catch (error) {
      dispatch(setNotification({ message: 'Login error', type: 'danger' }));
      console.error(error);
    }
  },
);

export const loginServcicePersonAction = createAsyncThunk<any, any>(
  'auth/getServcicePerson',
  async (employeeId, { dispatch, getState }) => {
    try {
      const { auth } = getState() as RootState;
      const servicePerson = await DictionaryApi.getServicePerson(employeeId, auth.company.value);

      if (!servicePerson) {
        dispatch(setNotification({ message: 'Employee Id not exist', type: 'danger' }));
      } else {
        setEmployeeId(employeeId);
        dispatch(
          setEmployee({
            firstName: servicePerson.FirstName || '',
            lastName: servicePerson.LastName || '',
            employeeId: employeeId,
          }),
        );
        history.goToCards({ from: 'employeeLogin' });
        sessionStorage.setItem('isNeedFocus', 'true');
      }

      return null;
    } catch (error) {
      dispatch(setNotification({ message: 'Login error', type: 'danger' }));
      console.error(error);
    }
  },
);
